(function() {

    'use strict';

    angular.module('app').
    controller('TruckLoadInformationAuditController', TruckLoadInformationAuditController);

    TruckLoadInformationAuditController.$inject = ['$scope','$window','TruckLoadInformationAuditTable'];

    function TruckLoadInformationAuditController($scope,$window,TruckLoadInformationAuditTable) {

        const vm = this;
        vm.back = back;
        init();

        function init() {
            vm.TruckLoadInformationAuditTable = new TruckLoadInformationAuditTable().tableData;
        }
        function back(){
            $window.history.back(); 
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/manifests/TruckInformationAuditController.js